// extracted by mini-css-extract-plugin
export default {"trackingItemsTable":"TrackingItemsScreen_trackingItemsTable__bEDjO"};